// extracted by mini-css-extract-plugin
export default {"BillMainBox":"WorkType_BillMainBox__mIZWC","BillNotCheck":"WorkType_BillNotCheck__RZoNN"};